<template>
  <div class="data-group-panel-v">
    <template v-if="items && items.length">
      <DataTitleGroup v-for="(item, index) in items"
                      :key="`item-${index}`"
                      :title="item.title"
                      fold>
        <template v-if="item.content">
          <DataPanelV v-bind="item.content"></DataPanelV>
        </template>
        <template v-else>
          <Hint type="empty">
            <div>分组内容为空</div>
          </Hint>
        </template>
      </DataTitleGroup>
    </template>
    <template v-else>
      <Hint type="empty">
        <div>条目数量为空</div>
      </Hint>
    </template>
  </div>
</template>

<script>
import DataTitleGroup from '../DataTitleGroup'
import Hint from '../../Hint'
export default {
  name: 'GroupPanel',
  components: {
    DataPanelV: () => import('../DataPanelV'),
    DataTitleGroup,
    Hint
  },
  props: {
    items: Array
  }
}
</script>

<style lang="scss" scoped>
.data-group-panel-v {
  height: 100%;

  ::v-deep .title-group {
    &:last-child {
      &.is-fold {
        &>.header {
          border-bottom: none;
        }
      }
    }
  }
}
</style>
